import { createSlice } from '@reduxjs/toolkit';
import { findSlider, createSlider, patchSlider } from './api';
import { initialState } from './api/interface';

const sliderSlice = createSlice({
  name: 'slider',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSlider.pending, (state) => {
      // Keep existing rows visible while refreshing (no full-page loader flash)
      if (!state.data.length) {
        state.isLoading = true;
      }
      state.status = 'pending';
    });
    builder.addCase(findSlider.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findSlider.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(createSlider.fulfilled, (state, action) => {
      state.data = [action.payload, ...state.data];
      state.totalRecords += 1;
    });
    builder.addCase(patchSlider.fulfilled, (state, action) => {
      const index = state.data.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  sliderSlice.actions;
export default sliderSlice.reducer;
